import styles from './cart-button.module.scss';
import React from "react";

import cart from "../../services/cart";

export interface CartButtonItem {
  slug: string;
  nombre: string;
  precio: number;
  unidad?: string;
  imagen?: string;
}

export interface CartButtonProps {
  name?: string;
  classes?: string;
  /** Item a agregar al carrito. */
  item: CartButtonItem;
  /** Cantidad (default 1). */
  qty?: number;
  /** Texto visible (precio / queso relevante). */
  children: React.ReactNode;
  onAdd?: (item: CartButtonItem) => void;
}

interface State {
  added: boolean;
}

/**
 * Botón (btn-link) con icono de carrito + "+" que agrega el item al carrito.
 * Al pasar el mouse muestra "Agregar al Carrito" (title); al clickear da un
 * feedback breve ("¡Agregado!").
 */
export default class CartButton extends React.Component<CartButtonProps, State> {
  static jsClass = "CartButton";
  static defaultProps: Partial<CartButtonProps> = {
    name: "mbCartButton",
    qty: 1,
  };

  state: State = { added: false };

  private timer?: ReturnType<typeof setTimeout>;

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  private add = () => {
    const { item, qty } = this.props;
    cart.add({ ...item, qty });
    this.setState({ added: true });
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.setState({ added: false }), 1400);
    this.props.onAdd?.(item);
  };

  render(): React.ReactNode {
    const { classes, children } = this.props;
    const { added } = this.state;
    const title = added ? "¡Agregado!" : "Agregar al Carrito";

    return (
      <button
        type="button"
        className={
          styles['mb-cart-btn'] + ' btn-link' + (classes ? ' ' + classes : '')
        }
        title={title}
        aria-label="Agregar al Carrito"
        onClick={this.add}>
        <span className={styles['mb-cart-btn__text']}>{children}</span>
        <span className={styles['mb-cart-btn__icon']} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="21" r="1.4" />
            <circle cx="19" cy="21" r="1.4" />
            <path d="M2 3h2.2l2.1 12.4a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L21 7H6" />
          </svg>
          <span className={styles['mb-cart-btn__plus']}>+</span>
        </span>
      </button>
    );
  }
}
